import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  ButtonModule,
  FcomFormsModule,
  IconsModule,
  ModalModule,
  NotificationsModule,
  UiComponentsModule,
} from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { CmsModule } from '@fcom/cms/components';
import { ComponentsModule, DirectiveModule, PipesModule } from '@fcom/common';
import { LocalizationProvider } from '@fcom/core/services/language/localization.provider';
import { CommonBookingComponentsModule } from '@fcom/common-booking/common-booking.module';
import { I18nKey } from '@fcom/core';
import { CommonBookingAncillariesModule } from '@fcom/common-booking';

import { BookingNotificationModule } from '../../components/booking-notification/booking-notification.module';
import { BookingCommonModule } from '../common/booking-common.module';
import { PurchaseReviewComponent } from './components/purchase-review/purchase-review.component';
import { PurchaseReviewFareRulesComponent } from './components/purchase-review-fare-rules/purchase-review-fare-rules.component';
import { BookingPurchaseReviewRouteComponent } from './routes/booking-purchase-review-route.component';
import { PurchaseReviewGuard } from './services/purchase-review.guard';
import { PaxDetailsModule } from '../pax-details/pax-details.module';
import { SafContributionProductComponent } from './components/saf-contribution-product/saf-contribution-product.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    CommonBookingComponentsModule,
    CommonBookingAncillariesModule,
    BookingCommonModule,
    CmsModule,
    PipesModule,
    DirectiveModule,
    UiTranslateModule,
    ButtonModule,
    FcomFormsModule,
    IconsModule,
    ModalModule,
    NotificationsModule,
    UiComponentsModule,
    BookingNotificationModule,
    PaxDetailsModule,
  ],
  declarations: [
    BookingPurchaseReviewRouteComponent,
    PurchaseReviewComponent,
    PurchaseReviewFareRulesComponent,
    SafContributionProductComponent,
  ],
  exports: [BookingPurchaseReviewRouteComponent],
  providers: [PurchaseReviewGuard],
})
export class PurchaseReviewModule {
  constructor(private localizationProvider: LocalizationProvider) {
    // TODO: Should we move the lazy mmb localization to booking localizations, so no need to load mmb here
    this.localizationProvider.triggerLazyLocalizations(I18nKey.MMB);
  }
}
